import { State } from '@hookstate/core';
import { GameState, isFreeGame } from '../stores/backend';
import { useGameType } from './use-game-type';

export const useCardBuy = (game: State<GameState>) => {
    const gameType = useGameType(game);

    let cardsToBuy = 1;

    const stripOnly = game.game_strip_only.value;
    const fixedGame = game.fixed_game.value;
    const stripSize = gameType === 90 ? 6 : 3; // 90-ball uses 6, all others (75, 80, 30) use 3
    const cardMax = game.game_cards_max.value || 0;

    const _isFreeGame = isFreeGame(game);

    if (stripOnly && !fixedGame) {
        cardsToBuy = stripSize;
    } else if (fixedGame) {
        cardsToBuy = fixedGame;
    } else if (_isFreeGame) {
        cardsToBuy = stripOnly ? cardMax / stripSize : cardMax;
    }

    return cardsToBuy;
};
